var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};

exports = function (source) {
  if ((this || _global).cacheable) this.cacheable();
  var value = typeof source === "string" ? JSON.parse(source) : source;
  value = JSON.stringify(value).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
  return `module.exports = ${value}`;
};

export default exports;